import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { PermissionService } from "../../../services";
import { Product, Subscription, SubscriptionOfUserResponseModel } from "../../../services/api";
import { AppState } from "../../../state";
import
{
    ClearRemovedSubscription,
    DeleteSubscription,
    ProductState,
    Unsubscribe
} from "../../product/state";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { SubscriptionHandlerComponent } from "../subscription-handler/subscription-handler.component";

@Component({
    selector: 'app-subscription-detail',
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatIconModule,
        MatTableModule,
        MatInputModule,
        MatButtonModule,
        MatTooltipModule
    ],
    templateUrl: './subscription-detail.component.html',
    styleUrls: ['./subscription-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SubscriptionDetailComponent extends SubscriptionHandlerComponent implements OnInit
{
    product$: Observable<Product> | undefined = this.store.select(ProductState.selectedProduct);

    userSubscriptions$: Observable<SubscriptionOfUserResponseModel[]> | undefined = this.store.select(AppState.userSubscriptions);

    @Input() useProduct: boolean;

    userMail: string | undefined;

    columns: string[] = ['CloudUserId', 'Language', 'CreatedBy', 'CreatedOn', 'Actions'];
    columns2: string[] = ['Product', 'Language', 'CreatedBy', 'CreatedOn', 'Actions'];

    constructor(private store: Store, private dialog: MatDialog, private permissionService: PermissionService)
    {
        super();
    }

    ngOnInit()
    {
        this.subscribeTo(this.permissionService.user$, x => this.userMail = x.mail);
    }

    // Delete Product Subscription
    deleteProductSubscription(subscription: Subscription)
    {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: "Delete Subscription",
                message: "Are you sure you want to delete this subscription?",
                confirmButtonText: "Delete",
                cancelButtonText: "Cancel"
            },
            disableClose: true,
            width: 'auto',
            height: 'auto'
        });

        dialogRef.afterClosed().subscribe(result =>
        {
            result && this.store.dispatch(new Unsubscribe(subscription.cancellationToken ?? ''));
        });
    }

    // Delete User Subscription
    deleteSubscription(subscription: SubscriptionOfUserResponseModel)
    {
        this.store.dispatch(new ClearRemovedSubscription());
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: "Delete User Subscription",
                message: "Are you sure you want to delete this user subscription?",
                confirmButtonText: "Delete",
                cancelButtonText: "Cancel"
            },
            disableClose: true,
            width: 'auto',
            height: 'auto'
        });

        dialogRef.afterClosed().subscribe(result =>
        {
            result && this.store.dispatch(new DeleteSubscription({
                productId: subscription.productId,
                languageId: subscription.subscriptionLanguage?.id,
                userMail: this.userMail
            }));
        });

        // this.subscribeTo(this.store.select(ProductApiStatusState.removedSubscription), x => {
        //     x && this.store.dispatch(new LoadUserSubscriptions());
        // });
    }
}
